export default {
    parts: ['container', 'title'],
    baseStyle: {
        container: {
            overflow: 'hidden',
            textAlign: 'center'
        },
        title: {
            margin: {base: '5px 0', lg: '0'},
            paddingBottom: {base: '10px', lg: '40px'},
            fontSize: {base: '25px', lg: '48px'},
            lineHeight: {base: 'normal', lg: '48px'},
            fontWeight: 700,
            textTransform: 'uppercase',
            color: 'gray.550',
            position: 'relative'
        }
    }
}
